<template>
    <div class="service-form">
        <div class="service-document">
            <div class="columns is-mobile is-vcentered mb-0">
                <div class="column is-centered is-3 enterprise-logo">
                    <img
                        class="logo"
                        :src="data.empresa != null ? data.empresa['logo_url'] : ''"
                        alt
                    />
                </div>
                <div class="column is-centered is-6 enterprise-info">
                    <h2>{{ data.empresa != null ? data.empresa.rsocial : '' }}</h2>
                    <h3>
                        {{
                            data.empresa != null
                                ? data.empresa.endereco +
                                  (data.empresa.endereco && data.empresa.cidade
                                      ? ' - ' + data.empresa.cidade
                                      : '')
                                : ''
                        }}
                    </h3>
                    <h3>{{ data.empresa != null ? data.empresa.cep : '' }}</h3>
                </div>
                <!-- A LOGO DO CLIENTE NÃO EXISTE ATUALMENTE, SE FUTURAMENTE FOR NECESSÁRIO, A ESTRUTURA JÁ ESTÁ PREPARADA, LOGO A VARIAVEL data.clientelog NÃO EXISTE -->
                <div class="column is-centered is-3 client-logo">
                    <img class="logo" :src="data.clientlogo" alt v-if="data.clientlogo" />
                </div>
            </div>

            <div class="form">
                <div class="form-client">
                    <div class="separator">
                        {{ $t('dados-nao-venda') }}
                    </div>
                    <div class="columns is-100 is-multiline is-mobile client-info is-gapless mb-0">
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('vendedor') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.nomeVendedor ? data.nomeVendedor : '-' }} </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('cliente') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span>
                                        {{ data.rsocialCliente ? data.rsocialCliente : '-' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('data') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span>
                                        {{
                                            data.datahora ? $moment(data.datahora).format('L') : '-'
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('contato') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.contato ? data.contato : '-' }} </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('observacao') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.observacao ? data.observacao : '-' }} </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('motivo') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span>
                                        {{ data.motivoNaoVenda ? data.motivoNaoVenda : '-' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="map-photo">
                        <div class="columns is-multiline is-gapless map-legend" v-if="hasLocations">
                            <div
                                class="map-legend-container column is-full is-flex is-flex-centered"
                            >
                                <div class="legend-item map-legend-item-left">
                                    <b-icon icon="home" :style="{ color: primary_color }" />
                                    <label>{{
                                        $t('cliente') +
                                        (!data.latCliente || !data.lngCliente
                                            ? ' (' + $t('sem-localizacao').toLowerCase() + ')'
                                            : '')
                                    }}</label>
                                    <b-icon 
                                        icon="information-outline" 
                                        size="is-small" 
                                        v-tippy 
                                        :title="$t('gps-cliente')"
                                    />
                                </div>
                                <div class="legend-item">
                                    <b-icon icon="map-marker" :style="{ color: tertiaryColor }" />
                                    <label>{{
                                        $t('check-in') +
                                        (!data.latCheck || !data.lngCheck
                                            ? ' (' + $t('sem-localizacao').toLowerCase() + ')'
                                            : '')
                                    }}</label>
                                    <b-icon 
                                        icon="information-outline" 
                                        size="is-small" 
                                        v-tippy 
                                        :title="$t('gps-check-in')"
                                    />
                                </div>
                                <div class="legend-item map-legend-item-right">
                                    <b-icon icon="map-marker" :style="{ color: secondary_color }" />
                                    <label>{{
                                        $t('nao-venda') +
                                        (!data.latNaoVenda || !data.lngNaoVenda
                                            ? ' (' + $t('sem-localizacao').toLowerCase() + ')'
                                            : '')
                                    }}</label>
                                    <b-icon 
                                        icon="information-outline" 
                                        size="is-small" 
                                        v-tippy 
                                        :title="$t('gps-geracao-nao-venda')"
                                    />
                                </div>
                            </div>
                            <div class="column is-full">
                                <img :src="mapimg" alt="mapa"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-client" v-if="hasClientDetails">
                    <div class="separator">
                        {{ $t('dados-cliente') }}
                    </div>

                    <div class="columns is-100 is-multiline is-mobile client-info is-gapless mb-0">
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('empresa') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span>
                                        {{
                                            data.empresa != null
                                                ? data.empresa.rsocial
                                                    ? data.empresa.rsocial
                                                    : '-'
                                                : '-'
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description">
                                        {{ $t('data-ultima-compra') + ': ' }}
                                    </span>
                                </div>
                                <div class="column">
                                    <span>
                                        {{
                                            data.clientedetalhe.dataUltimaCompra == null
                                                ? '-'
                                                : $moment(
                                                      data.clientedetalhe.dataUltimaCompra
                                                  ).format('L')
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description">
                                        {{ $t('dias-sem-venda') + ': ' }}
                                    </span>
                                </div>
                                <div class="column">
                                    <span>
                                        {{
                                            data.clientedetalhe.diasSemVenda == null
                                                ? '-'
                                                : data.clientedetalhe.diasSemVenda
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description">
                                        {{ $t('ticket-medio-reais') + ':* ' }}
                                    </span>
                                </div>
                                <div class="column">
                                    <span>
                                        {{
                                            data.clientedetalhe.ticketMedio == null
                                                ? '-'
                                                : data.clientedetalhe.ticketMedio.toLocaleString(
                                                      'pt-BR',
                                                      { style: 'currency', currency: 'BRL' }
                                                  )
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description">
                                        {{ $t('valor-maior-venda') + ': ' }}
                                    </span>
                                </div>
                                <div class="column">
                                    <span>
                                        {{
                                            data.clientedetalhe.valorMaiorVenda == null
                                                ? '-'
                                                : data.clientedetalhe.valorMaiorVenda.toLocaleString(
                                                      'pt-BR',
                                                      { style: 'currency', currency: 'BRL' }
                                                  )
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description">
                                        {{ $t('valor-menor-venda') + ': ' }}
                                    </span>
                                </div>
                                <div class="column">
                                    <span>
                                        {{
                                            data.clientedetalhe.valorMenorVenda == null
                                                ? '-'
                                                : data.clientedetalhe.valorMenorVenda.toLocaleString(
                                                      'pt-BR',
                                                      { style: 'currency', currency: 'BRL' }
                                                  )
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description">
                                        {{ $t('prazo-medio-dias') + ':* ' }}
                                    </span>
                                </div>
                                <div class="column">
                                    <span>
                                        {{
                                            data.clientedetalhe.prazoMedio == null
                                                ? '-'
                                                : data.clientedetalhe.prazoMedio +
                                                  ' ' +
                                                  $t(
                                                      data.clientedetalhe.prazoMedio > 1
                                                          ? 'x-dias'
                                                          : 'x-dia'
                                                  )
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description">
                                        {{ $t('cliente-compra-media') + ':* ' }}
                                    </span>
                                </div>
                                <div class="column">
                                    <span>
                                        {{
                                            data.clientedetalhe.compraEmMedia == null
                                                ? '-'
                                                : data.clientedetalhe.compraEmMedia +
                                                  ' ' +
                                                  $t(
                                                      data.clientedetalhe.compraEmMedia > 1
                                                          ? 'x-dias'
                                                          : 'x-dia'
                                                  )
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description">
                                        {{ $t('quantidade-nao-vendas-sem-compra') + ':* ' }}
                                    </span>
                                </div>
                                <div class="column">
                                    <span>
                                        {{
                                            data.clientedetalhe.naoVendasSemCompra == null
                                                ? '-'
                                                : data.clientedetalhe.naoVendasSemCompra
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="map-photo">
                        <p>{{ '* ' + $t('info-dados-ultimo-ano') }}</p>
                    </div>
                </div>

                <div class="form-client" v-if="data.fotos && data.fotos.length > 0">
                    <div class="separator">
                        {{ $t('fotos') + ' (' + numFotos + ')' }}
                    </div>
                    <div class="columns is-mobile is-multiline is-100">
                        <div
                            class="column is-half-mobile is-half-tablet is-one-third-desktop is-one-quarter-widescreen"
                            v-for="(ft, i) in data.fotos"
                            :key="i"
                        >
                            <div class="card img-wrapper">
                                <img :src="ft.url_documento" alt />
                                <div class="legend">
                                    <p>{{ ft.datahora | moment('L LT') }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="data-block-img">
                        <div class="option">
                            <div class="opt-img-block" v-for="(ft, i) in data.fotos" :key="i">
                                <div>     
                                    <div class="opt-img">
                                        <img :src="ft.url_documento" alt>
                                    </div>
                                    <div class="opt-legend">
                                        <p>{{ ft.datahora | moment('L LT') }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VendasRelJustificativaNaoVendaService from '@/services/VendasRelJustificativaNaoVendaService';
import { palette as paleta } from '@/functions/color/Palette';

export default {
    data() {
        return {
            mapimg: '',
            data: {},
            numFotos: 0,
            hasLocations: false,
            hasClientDetails: false,
            primary_color: this.$store.state.partnerSystemHasLayout.primary_color,
            secondary_color: paleta.getChartColors()[paleta.getChartColors().length - 1],
            tertiaryColor: paleta.getChartColors()[3],
        };
    },
    props: {
        idnaovenda: 0,
    },

    created() {
        this.service = new VendasRelJustificativaNaoVendaService(this.$http, this.$router);
        this.loadData(this.idnaovenda);
    },
    mounted() {},
    methods: {
        hasLoc(report) {
            let hasClientLocation = report.latCliente && report.lngCliente;
            let hasNaoVendaLocation = report.latNaoVenda && report.lngNaoVenda;
            return hasClientLocation;
        },
        loadData(idnaovenda) {
            this.$store.commit('addLoader');
            this.service
                .find(idnaovenda)
                .then((res) => {
                    this.data = res.content;
                    if (this.hasLoc(res.content)) {
                        if (this.$store.state.user.gmapsApiKey) {
                            this.hasLocations = true;
                            let posCli = {
                                lat: res.content.latCliente,
                                lng: res.content.lngCliente,
                            };
                            let posCheck = { lat: res.content.latCheck, lng: res.content.lngCheck };
                            let posNaoVenda = {
                                lat: res.content.latNaoVenda,
                                lng: res.content.lngNaoVenda,
                            };
                            this.getMapImgUrl(posCli, posCheck, posNaoVenda);
                        }
                    }
                    this.numFotos = res.content.fotos.length;

                    if (res.content.idCliente != null) {
                        this.service
                            .getClienteDetalhesInfo(res.content.idCliente)
                            .then((cli) => {
                                this.data.clientedetalhe = cli.content;
                                this.hasClientDetails = true;
                            })
                            .catch((er) => {
                                this.$root.showMessage('error', 'msg-erro-relatorio');
                            });
                    }

                    if (res.content.empresa == null) {
                        this.$root.alert({
                            message: this.$t('msg-usuario-sem-empresa'),
                            onConfirm: () => {
                                this.redirect(0);
                            },
                        });
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-relatorio');
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                });
        },
        getMapImgUrl(posCli, posCheck, posNaoVenda) {
            let googleMapsApiKey = this.$CryptoJS.AES.decrypt(
                this.$store.state.user.gmapsApiKey,
                atob('UzBWMVMyMDA3UzBWMVMyMDE5UzBWMVMuIUAj')
            ).toString(this.$CryptoJS.enc.Utf8);

            let urlBase =
                'https://maps.googleapis.com/maps/api/staticmap?size=640x200&style=feature:water|element:geometry|visibility:on&style=feature:landscape|element:geometry|visibility:on&scale=1&key=' +
                googleMapsApiKey; // AIzaSyCJCQZ3vFYpmnlm1bCpTHZiuz5g3PqDg4w (estava hardcoded, trocado pela key do usuario)

            if (posCli.lat && posCli.lng) {
                let cor = this.primary_color.replace('#', ''); // cor primária do cliente
                let size = 32;
                urlBase +=
                    '&markers=anchor:' +
                    (size / 2).toFixed(0) +
                    ',' +
                    (size / 2).toFixed(0) +
                    '|icon:https://img.icons8.com/material-rounded/' +
                    size +
                    '/' +
                    cor +
                    '/home.png|' +
                    posCli.lat +
                    ',' +
                    posCli.lng;
            }

            if (posCheck.lat && posCheck.lng) {
                let cor = this.tertiaryColor.replace('#', ''); // cor terciária do cliente
                let size = 32;
                urlBase +=
                    '&markers=anchor:' +
                    (size / 2).toFixed(0) +
                    ',' +
                    size +
                    '|icon:https://img.icons8.com/ios-filled/' +
                    size +
                    '/' +
                    cor +
                    '/marker.png|' +
                    posCheck.lat +
                    ',' +
                    posCheck.lng;
            }

            if (posNaoVenda.lat && posNaoVenda.lng) {
                let cor = this.secondary_color.replace('#', ''); // cor secundária do cliente
                let size = 32;
                urlBase +=
                    '&markers=anchor:' +
                    (size / 2).toFixed(0) +
                    ',' +
                    size +
                    '|icon:https://img.icons8.com/ios-filled/' +
                    size +
                    '/' +
                    cor +
                    '/marker.png|' +
                    posNaoVenda.lat +
                    ',' +
                    posNaoVenda.lng;
            }

            this.mapimg = urlBase;
        },
        getData(data) {
            if (data) {
                return data.split('-').reverse().join('/');
            } else {
                return '';
            }
        },
        redirect(time) {
            setTimeout(() => {
                this.$router.push({ name: 'ven-cockpit' });
            }, time * 1000);
        },
    },
    watch: {},
};
</script>
<style lang="scss" scoped>
.with-spacer {
    margin-right: 0.5rem !important;
}
.service-form {
    .service-document {
        background: $sovis-white;
        height: 100%;
        padding: 20px;

        .enterprise-logo,
        .client-logo {
            .logo {
                height: auto;
                max-height: 80px;
            }
        }
        .enterprise-info {
            h2 {
                text-align: center;
                font-size: 18px;
                font-weight: 600;
            }
            h3 {
                text-align: center;
                font-size: 12px;
            }
        }
        .report-title {
            font-size: 20px;
            margin-bottom: 10px;

            h1 {
                font-weight: 600;
            }
        }

        .form {
            width: 100%;

            .form-client {
                width: 100%;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                margin-bottom: 20px;

                .separator {
                    width: 100%;
                    border-top: 1px solid $table-border;
                    border-bottom: 1px solid $table-border;
                    padding: 10px 0;
                    text-align: center;
                    margin-bottom: 10px;
                    font-weight: 600;
                    font-size: 18px;
                }

                .client-info {
                    .description {
                        font-weight: 600;
                        // font-size: 16px;
                        margin-bottom: 0px;
                    }
                    .info {
                        margin-bottom: 0.5rem;
                    }
                }

                .data-block-alt {
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;

                    .client-info {
                        width: 20%;
                    }
                }

                .data-block-form {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;

                    .client-info {
                        width: 100%;
                        display: flex;
                        justify-content: flex-start;

                        h4,
                        p {
                            width: 20%;
                        }
                    }
                }

                .img-wrapper {
                    padding: 10px;
                    height: max-content;

                    img {
                        width: 100%;
                        height: 200px;
                        object-fit: contain;
                    }

                    .legend,
                    .opt-obs {
                        font-size: 12px;
                        display: flex;
                        justify-content: space-between;
                        margin-top: 5px;

                        p {
                            width: 100%;
                            text-align: center;
                            text-transform: uppercase;
                        }
                        .icon-location {
                            width: 25%;
                            text-align: right;
                            .svg-icons {
                                width: 30px;
                                height: 30px;
                            }
                        }

                        .opt-text {
                            display: flex;
                            flex-wrap: wrap;

                            p {
                                width: 100%;
                            }
                        }
                    }

                    &.share,
                    &.pesquisa {
                        .client-info {
                            h4,
                            p {
                                width: 10%;
                                &.bigger {
                                    width: 60%;
                                }
                            }
                        }
                    }
                }

                .map-photo {
                    text-align: center;
                    width: 100%;
                    margin-top: 10px;

                    img {
                        border: 1px solid $table-border;
                        max-width: 100%;
                    }

                    .map-legend {
                        display: flex;

                        .map-legend-container {
                            .legend-item {
                                text-align: left;
                                margin-left: 30px;
                                margin-right: 30px;
                            }
                        }
                    }
                }
            }

            .assinatura {
                margin-top: 80px;
                margin-right: 20px;
                width: 300px;
                height: 300px;

                .opt-img {
                    border-bottom: 1px solid $table-border;
                    width: 300px;
                    height: 250px;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                .opt-legend,
                .opt-obs {
                    font-size: 12px;
                    display: flex;
                    justify-content: space-between;
                    margin-top: 5px;

                    p {
                        width: 100%;
                    }
                }
            }
        }
    }
}
</style>
